module.exports = __webpack_public_path__ + "static/intranet-df2b37570080a566a975288664e5b3a2.jpg";